import { useMemo } from 'react'
import styled from 'styled-components'

import { presets } from '../presets'
import { getFileIcon } from 'components/file/fileHelper'

import CustomIcon from 'components/icon/CustomIcon'

interface IOtherFileProps {
  mimetype: string
  preset:
    | 'preview'
    | 'input'
    | 'files'
    | 'fullscreen'
    | 'post'
    | 'editPost'
    | 'postInput'
    | 'editPostResponsive'
}

const OtherFile = ({ mimetype, preset }: IOtherFileProps) => {
  const icon = useMemo(() => getFileIcon(mimetype), [mimetype])
  
  if (preset === 'fullscreen') {
    return <FullscreenIconWithSize source={icon} />
  }
  
  // post, files veya postInput preset durumunda özel boyutlar kullanın
  if (preset === 'post' || preset === 'postInput' || preset === 'files') {
    return <CustomIconWithSize source={icon} preset={preset} />
  }
  
  return <StyledOtherFile source={icon} {...presets[preset].other} preset={preset} />
}

export default OtherFile

const StyledOtherFile = styled(CustomIcon).attrs(
  (props: { preset: string; maxWidth: string, maxHeight: string, borderRadius: string }) => props,
)`
  width: ${({ preset, maxWidth }) => (preset === 'files' ? maxWidth : 'auto')}; 
  max-width: ${({ maxWidth }) => maxWidth};
  max-height: ${({ maxHeight }) => maxHeight};
  border-radius: ${({ borderRadius }) => borderRadius};
`

const FullscreenIconWithSize = styled(CustomIcon)`
  width: 120px;
  height: 120px;
  min-width: 120px;
  min-height: 120px;
`

const CustomIconWithSize = styled(CustomIcon).attrs((props: { preset: string }) => props)`
  width: ${({ preset }) => {
    if (preset === 'post') return '60px';
    if (preset === 'postInput') return '60px';
    return '36px';
  }};
  height: ${({ preset }) => {
    if (preset === 'post') return '60px';
    if (preset === 'postInput') return '60px';
    return '36px';
  }};
  min-width: ${({ preset }) => {
    if (preset === 'post') return '60px';
    if (preset === 'postInput') return '65px';
    return '36px';
  }};
  min-height: ${({ preset }) => {
    if (preset === 'post') return '60px';
    if (preset === 'postInput') return '60px';
    return '36px';
  }};
`
